module.exports = __webpack_public_path__ + "static/media/business-report.c536d840.png";